import { useMemo } from 'react';
import { TCryptoJS } from '../basis/types/tcrypto-js';
import { decrypt } from '../utils/crypto-js';

// 计算明文会议密码
export const useMeetingBrightPassword = (password?: string, nonce?: string) => {
  const brightPassword = useMemo(
    () => (password && nonce ? decrypt({ str: password, key: nonce, iv: TCryptoJS.MEET_CLIENT_IV }) : ''),
    [password, nonce],
  );

  return { brightPassword };
};
